import React from 'react';

const ServiceBanner = () => {
  return (
    <div className="bg-parlor-green-dark text-parlor-cream py-4 border-y border-parlor-gold/30">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-sm md:text-base font-light tracking-wide text-balance">
          Proudly serving the <span className="text-parlor-gold font-medium">Chicagoland Area & the North Shore</span> for live events. 
          <span className="hidden md:inline"> | </span>
          <br className="md:hidden" />
          Nationwide shipping available for all online orders.
        </p>
      </div>
    </div>
  );
};

export default ServiceBanner;